import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtilsLegacy';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTablePriceDisplay = ({
  apiName
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    monthlyCalculatedPrice: price,
    loading: priceLoading
  } = useCalculatedPrice({
    apiName,
    queryParamTerm
  });
  const seleniumId = apiName || 'loading';
  if (!price && !priceLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: priceLoading,
    heights: [20],
    widths: [75],
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "featureTable.pricing_jsx",
        elements: {
          PriceDisplay
        },
        options: {
          currencyCode,
          seleniumId,
          price
        }
      })
    })
  });
};
export default FeatureTablePriceDisplay;